module.exports = __webpack_public_path__ + "static/img/product_society_society_xft.facd896.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_xft.svg
// module id = AkPP
// module chunks = 0